
























































import Vue from "vue";
import loading from "vue-full-loading";
import { Component, Watch } from "vue-property-decorator";
import {
  ShipmentDTO,
  AddressShipmentDTO,
  ShipmentExtraServiceDTO,
  ContactDTO,
  DepartmentDTO,
  AddressLocatorDto,
  ShipmentDetailsOutputDTO,
  MessageResult
} from "../../../model/data.model";
import Address from "./Address.vue";
import ShipmentForm from "./ShipmentForm.vue";
import Calculator from "./Calculator.vue";
import PostSaveModal from "./PostSaveModal.vue";
import { ShipmentService } from "../../../services/ShipmentService";
import FullScreenModal from "../../shared/modal/FullScreenModal.vue";
import { EventBus } from "../../../event-bus";
import { AlertBus } from "../../../plugins/alerts/AlertBus";
import i18n, { hasTranslation } from "../../../lang/i18n";
import router from "../../../router/router";
import store from "../../../vuex/store";
import { ContactService } from "../../../services/ContactService";
import { CustomerService } from "../../../services/CustomerService";
import { getStoreCompanyName, translateErrorMessage } from "@/services/Helpers";
import { reportError } from "@/utils/instana";
import {
  SpecialtyTypeBusiness,
  SurchargeExtraServiceBusiness
} from "@/model/enumeration.model";
import { Page } from "@/model/component.model";
import { Debounce } from "vue-debounce-decorator";

@Component({
  components: {
    ShipmentForm: ShipmentForm,
    postsaveModal: PostSaveModal,
    mbeFullScreenModal: FullScreenModal,
    loading: loading
  }
})
export default class NewShipment extends Vue {
  shipment: ShipmentDTO = new ShipmentDTO();
  newCreatedShipment = false;
  ready = false;
  hasInvalidPackageDimension = false;
  senderAddressOperation = "NEW";
  receiverAddressOperation = "NEW";
  senderContact: ContactDTO | undefined = undefined;
  receiverContact: ContactDTO | undefined = undefined;
  contactService: ContactService;
  canRequestCustomDuties = false;
  // used another var to call update contact api, instead of visible flag, to keep user experience as before
  overwriteSenderContactInfos = false;
  overwriteReceiverContactInfos = false;
  attachments = [];

  get packagesAmount() {
    return this.shipment.shipmentPackages.length;
  }

  get hasAccessPointData() {
    return (
      this.shipment.addressAccessPoint &&
      Object.keys(this.shipment.addressAccessPoint).length > 0
    );
  }

  updateShipment(shipment: ShipmentDTO) {
    this.shipment = shipment;
  }

  fixPackagesForDeliveryPoint() {
    if (this.packagesAmount === 1) return;

    Vue.set(this.shipment, "shipmentPackages", [
      this.shipment.shipmentPackages[0]
    ]);
  }
  getCustomerAndAddressess() {
    if (this.isInboundShipment) {
      this.receiverAddressOperation = "DONTSAVE";
    }
    if (!this.isInboundShipment) {
      this.senderAddressOperation = "DONTSAVE";
    }
    this.shipment.customerId = this.$store.getters["customer/info"].customerId;
    this.shipment.customerName = this.$store.getters[
      "customer/info"
    ].businessName;
    // Selection of default department if user has it assigned -- logica assegnazione indirizzo
    const user_config = this.$store.getters["customer/config"];
    if (
      typeof user_config.onlySelectedDepartments !== "undefined" &&
      user_config.onlySelectedDepartments
    ) {
      this.setDefaultDepartment(user_config, true);
    } else if (
      typeof user_config.departmentId !== "undefined" &&
      user_config.departmentId !== undefined &&
      user_config.departmentId !== null &&
      user_config.departmentId !== 0
    ) {
      this.setDefaultDepartment(user_config, false);
    } else {
      this.shipment.customerDepartmentId = 0;
      this.setAddressForAsCustomer();
    }
  }

  async created() {
    this.getCustomerAndAddressess();

    this.getCorrectionSettings();

    this.shipment.storeId = this.$store.getters["customer/info"].defaultStoreId;
    this.shipment.locale = this.$store.getters["timeZoneId"];
    // Set destination country the same as store country, as domestic
    // shipment is the first option
    this.shipment.addressTo.countryId = this.$store.getters[
      "customer/storeAddresses"
    ][0].countryId;
    this.shipment.addressTo.countryName = this.$store.getters[
      "customer/storeAddresses"
    ][0].countryName;

    this.ready = true;

    this.contactService = new ContactService(
      this.$store.getters["customer/customerMbeId"]
    );
    // Load default shipment template -- popolazione sender -- nome chiamata online
    CustomerService.loadDefaultShipmentTemplate(
      this.$store.getters["customer/info"].customerId,
      this.$store.getters["customer/config"].username
    )
      .then(res => {
        if (
          res &&
          res.weight !== undefined &&
          res.height !== undefined &&
          res.width !== undefined &&
          res.depth !== undefined &&
          !this.$route.params.calculated &&
          this.$store.getters["customer/config"]
            .enableSaveDefaultShipmentSettings
        ) {
          this.shipment.shipmentPackages[0].customerWeight = res.weight;
          this.shipment.shipmentPackages[0].courierWeight = res.weight;
          this.shipment.customerWeight = res.weight;
          this.shipment.courierWeight = res.weight;
          this.shipment.shipmentPackages[0].height = res.height;
          this.shipment.shipmentPackages[0].depth = res.depth;
          this.shipment.shipmentPackages[0].width = res.width;
          this.shipment.goodDescription = res.content;
        }
      })
      .catch(err => {
        throw err;
      });
    const id = this.$route.params.id
      ? this.$route.params.id
      : (this.$route.query.id as string);
    const duplicate = this.$route.params.duplicate;
    const calculated = this.$route.params.calculated;
    const draft = this.$route.params.draft
      ? this.$route.params.draft
      : this.$route.query.draft;
    if (id != null && duplicate === "duplicate") {
      this.newCreatedShipment =
        this.$route.params.newCreatedShipment === "true";

      ShipmentService.getShipment(id)
        .then(res => {
          res = ShipmentService.duplicateShipment(res, true);
          this.shipment = ShipmentDTO.cloneShipment(res);

          if (this.shipment.paperlessDocumentIds) {
            ShipmentService.prototype
              .getPaperlessContentDocumentsByIds(
                this.shipment.paperlessDocumentIds
              )
              .then((paperlessContentList: any) => {
                if (paperlessContentList) {
                  paperlessContentList.forEach((paperlessContent: any) => {
                    if (
                      paperlessContent.courierDocumentTypeCode ===
                        "PRO_FORMA_INVOICE" ||
                      paperlessContent.courierDocumentTypeCode === "PROFORMA"
                    ) {
                      if (this.shipment.paperlessDocumentIds) {
                        this.shipment.paperlessDocumentIds.splice(
                          this.shipment.paperlessDocumentIds.indexOf(
                            paperlessContent.id
                          ),
                          1
                        );
                      }
                    }
                  });
                }
              });
          }

          this.shipment.priceSource = res.priceSource;
          if (
            !this.shipment.addressStore.macroareaName ||
            this.shipment.addressStore.macroareaName === ""
          ) {
            //workaround for some bad addresses from BE, they should fix on their side later
            // temp workaournd for 748724888
            this.refreshStoreAddress();
          }
          this.ready = true;
        })
        .catch(error => {});
    }
    this.getDraft(id, draft);
    if (calculated === "calculated") {
      this.newCreatedShipment =
        this.$route.params.newCreatedShipment === "true";
      const ship = JSON.parse(this.$route.params.ship);
      this.shipment = ShipmentDTO.cloneShipment(ship);
      this.shipment.priceSource = ship.priceSource;
      if (
        !this.shipment.addressStore.macroareaName ||
        this.shipment.addressStore.macroareaName === ""
      ) {
        //workaround for some bad addresses from BE, they should fix on their side later
        // temp workaournd for 748724888
        this.refreshStoreAddress();
      }
      this.shipment.customerId = this.$store.getters[
        "customer"
      ].info.customerId;
      this.shipment.customerName = this.$store.getters[
        "customer"
      ].info.businessName;
      this.shipment.storeId = this.$store.getters[
        "customer/info"
      ].defaultStoreId;
      this.shipment.locale = this.$store.getters["timeZoneId"];
      this.shipment.courierWeight = this.shipment.customerWeight;
      this.ready = true;
      this.setDelivery();
    }
  }
  async getDraft(id: string, draft: any) {
    if (id != null && draft === "draft") {
      this.newCreatedShipment =
        this.$route.params.newCreatedShipment === "true";
      const res = await ShipmentService.getShipment(id);
      this.shipment = ShipmentDTO.cloneShipment(res);
      if (this.isInboundShipment) {
        this.senderAddressOperation = "OVERWRITE";
      }

      if (
        !this.isInboundShipment &&
        this.shipment &&
        this.shipment.addressTo &&
        this.shipment.addressTo.addressId
      ) {
        this.receiverAddressOperation = "OVERWRITE";
      } else if (!this.isInboundShipment) {
        this.receiverAddressOperation = "DONTSAVE";
      }

      this.shipment.priceSource = res.priceSource;
      if (
        !this.shipment.addressStore.macroareaName ||
        this.shipment.addressStore.macroareaName === ""
      ) {
        //workaround for some bad addresses from BE, they should fix on their side later
        // temp workaournd for 748724888
        this.refreshStoreAddress();
      }
      (this.$refs.shipmentForm as ShipmentForm).isDraft = 0;

      await this.$nextTick();
      this.ready = true;
    }
  }

  @Debounce(100)
  setDelivery() {
    if (this.shipment.mbeServiceId === 11) {
      (this.$refs.shipmentForm as ShipmentForm).isDeliveryPointSelected = true;
    }
  }

  setDefaultDepartment(user_config: any, onlySelectedDepartments: boolean) {
    this.shipment.customerDepartmentId = user_config.departmentId;
    const departments = this.$store.getters["customer/departments"];
    const filteredDepartments = departments.filter((item: DepartmentDTO) => {
      return item.departmentId === this.shipment.customerDepartmentId;
    });

    const foundDepartmentData: boolean =
      !onlySelectedDepartments ||
      (filteredDepartments !== undefined &&
        filteredDepartments.length > 0 &&
        departments !== undefined &&
        departments.length > 0 &&
        departments
          .map((d: DepartmentDTO) => d.departmentId)
          .includes(this.shipment.customerDepartmentId));

    if (!foundDepartmentData) {
      this.shipment.customerDepartmentId = 0;
    }

    if (filteredDepartments.length > 0 && foundDepartmentData) {
      this.shipment.customerDepartment =
        filteredDepartments[0].departmentBusinessName;
      if (filteredDepartments[0].address.addresses.length > 0) {
        this.shipment.addressFor = AddressShipmentDTO.fromContactDTO(
          filteredDepartments[0].address,
          filteredDepartments[0].address.addresses[0],
          this.$store.getters["customer/info"].vatNumber,
          "NATIONAL",
          filteredDepartments[0].departmentBusinessName,
          this.$store.getters["customer/info"].eori,
          this.$store.getters["customer/info"].fiscalCode
        );
        this.calculateMacroAreaForAddress("addressFor");
        if (this.isInboundShipment) {
          setTimeout(() => {
            this.shipment.addressTo = AddressShipmentDTO.fromContactDTO(
              filteredDepartments[0].address,
              filteredDepartments[0].address.addresses[0],
              this.$store.getters["customer/info"].vatNumber,
              "NATIONAL",
              filteredDepartments[0].departmentBusinessName,
              this.$store.getters["customer/info"].eori,
              this.$store.getters["customer/info"].fiscalCode
            );
            this.calculateMacroAreaForAddress("addressTo");
          });
        }
      }
    } else {
      this.setAddressForAsCustomer();
    }
  }

  resetCourier() {
    this.shipment = { ...this.shipment, courierId: 0, courierName: "" };
  }

  resetCourierService() {
    this.shipment = {
      ...this.shipment,
      courierServiceId: 0,
      courierServiceName: ""
    };
  }

  get lastDetails() {
    return this.$store.getters[
      "shipment/lastDetails"
    ] as ShipmentDetailsOutputDTO | null;
  }

  updateShipmentAccessPoint(accessPoint?: AddressLocatorDto) {
    Vue.set(this.shipment, "addressAccessPoint", accessPoint);
  }

  setAddressForAsCustomer() {
    const customerBusinessName = this.$store.getters["customer/info"]
      .businessName;
    const customerContact = this.$store.getters["customer/info"].address;
    if (customerContact.addresses.length >= 1) {
      this.shipment.addressFor = AddressShipmentDTO.fromContactDTO(
        customerContact,
        customerContact.addresses[0],
        "",
        "NATIONAL",
        customerBusinessName
      );
    }
    this.calculateMacroAreaForAddress("addressFor");
  }

  calculateMacroAreaForAddress(addressType: string) {
    store.cache
      .dispatch("shipment/getMacroareaForContact", {
        zipCode: this.shipment[addressType].zipCode,
        countryId: this.shipment[addressType].countryId
      })
      .then(value => (this.shipment[addressType].macroareaName = value));
  }

  fromAddressShipmentToContact(value: AddressShipmentDTO) {
    this.senderContact = {
      molUsername: this.$store.getters.customer.config.username,
      firstname: value.companyName,
      lastname: "",
      contactType: "CONTACT",
      gender: "",
      birthDate: "1980-01-01",
      addresses: [
        {
          address: value.address,
          city: value.city,
          countryId: value.countryId,
          countryName: value.countryName,
          flavour: "NONE",
          ltz: false,
          province: value.province,
          secondAddress: value.secondAddress,
          state: value.subcountry,
          thirdAddress: value.thirdAddress,
          type: "OPERATION",
          zipCode: value.zipCode,
          pickupExemption: false,
          tenantId: -1
        }
      ],
      contactsReference: [
        {
          type: "EMAIL1",
          value: value.email
        },
        {
          type: "CONTACT_NAME",
          value: value.contact
        },
        {
          type: "TELEPHONE1",
          value: value.phone
        },
        {
          type: "TELEPHONE2",
          value: value.secondPhone
        },
        {
          type: "EMAIL2",
          value: value.secondEmail
        },
        {
          type: "FAX",
          value: value.fax
        }
      ]
    };
  }

  saveShipment(draft?: boolean) {
    try {
      this.shipment.extraServices = this.shipment.extraServices.filter(
        (el: any) => el.price
      );
      if (this.isInboundShipment) {
        this.shipment.shipmentDirection = "INBOUND";
      } else {
        this.shipment.shipmentDirection = "OUTBOUND";
      }
      if (this.shipment.customerDepartmentId === 0) {
        this.setAddressForAsCustomer();
      }
      if (!this.canRequestCustomDuties) {
        this.shipment.customsDutiesToCustomer = null;
      }
      const storeAddresses = this.$store.getters["customer/storeAddresses"];
      const storeName = getStoreCompanyName(
        this.$store.getters["customer/storeInfo"].store.multiStore
      );
      if (storeAddresses.length >= 1) {
        this.shipment.addressStore = AddressShipmentDTO.fromAddressDTO(
          storeAddresses[0],
          storeName,
          "",
          "NATIONAL",
          this.$store.getters["customer/storeInfo"].contactReferences
        );
      }

      this.shipment.totalNumberOfPackages = this.shipment.shipmentPackages.length;
      this.checkSafeValue();
      this.checkSafeValue4B();

      (this.$refs.shipmentForm as ShipmentForm)
        .fillCourierAccountIfNecessary()
        .then(async () => {
          // this.confirmSaveShipment()
          //   .then(() => {
          // Operations over addresses
          const senderPromise = new Promise((resolve, reject) => {
            switch (this.senderAddressOperation) {
              case "NEW":
                this.contactService
                  .saveContact(this.shipment.addressFrom.toContactDTO())
                  .then(res => {
                    this.shipment.addressFrom.addressId = res.id;
                    resolve();
                  });
                break;
              case "OVERWRITE":
                if (this.overwriteSenderContactInfos) {
                  this.contactService.updateContact(
                    this.shipment.addressFrom.toContactDTO(this.senderContact),
                    []
                  );
                }
                resolve();
                break;
              case "DONTSAVE":
                resolve();
                break;
              case "SAVEASPICKUP":
                this.fromAddressShipmentToContact(this.shipment.addressFrom);
                this.contactService
                  .saveContact(this.senderContact as ContactDTO)
                  .then(res => {
                    this.shipment.addressFrom.addressId = res.id;
                    resolve();
                  });
                break;
            }
          });
          const receiverPromise = new Promise((resolve, reject) => {
            switch (this.receiverAddressOperation) {
              case "NEW":
                this.contactService
                  .saveContact({
                    ...AddressShipmentDTO.cloneAddress(
                      this.shipment.addressTo
                    ).toContactDTO(),
                    molUsername: this.$store.getters.customer.config.username
                  })
                  .then(res => {
                    this.shipment.addressTo.addressId = res.id;
                    resolve();
                  });
                break;

              case "OVERWRITE":
                if (this.overwriteReceiverContactInfos) {
                  this.contactService.updateContact(
                    AddressShipmentDTO.cloneAddress(
                      this.shipment.addressTo
                    ).toContactDTO(this.receiverContact),
                    []
                  );
                }
                resolve();
                break;
              case "DONTSAVE":
                resolve();
                break;
            }
          });
          await Promise.all([senderPromise, receiverPromise]);
          (this.$refs.shipmentForm as ShipmentForm).canSaveShipment = true;
          this.confirmSaveShipment(draft)
            .then()
            .catch(err => {
              EventBus.$emit("hide-my-full-loading");
              let message =
                "<h5>" + this.$t("FIX_BEFORE_CONTINUE") + "</h5></br>";
              message += "<p>" + translateErrorMessage(err) + "</p>";
              if (err?.response?.status === 400) {
                const objectErr =
                  err.response.data.length > 0
                    ? err.response.data[0]
                    : err.response.data;
                reportError(err, {
                  meta: { response: JSON.stringify(objectErr) }
                });
              }
              return AlertBus.$alerts.danger(message);
            });
        });
    } catch (error) {
      console.error(error);
    }
  }

  changeProvince(data: { value: string; field: string; isItaly: boolean }) {
    if (this.shipment.courierName === "UPS" || data.isItaly) {
      this.shipment.addressFrom.province =
        data.field === "from" ? data.value.toUpperCase() : data.value;
      this.shipment.addressTo.province =
        data.field === "to" ? data.value.toUpperCase() : data.value;
    } else {
      this.shipment.addressFrom.province =
        data.field === "from" ? data.value : this.shipment.addressFrom.province;
      this.shipment.addressTo.province =
        data.field === "to" ? data.value : this.shipment.addressTo.province;
    }
  }

  get isInboundShipment() {
    return (
      this.$route.query.type === "inbound" &&
      this.$store.getters.features.inbound
    );
  }

  get isWineShipment() {
    return (
      (this.$route.query.type === "wine" || this.hasWineProduct) &&
      (this.$store.getters["customer/config"].enableWineShipmentCreation ||
        this.$store.getters["customer/config"].enableSpiritsShipmentCreation)
    );
  }

  get hasWineProduct() {
    const validIds = [6, 8, 9, 10];
    return (
      this.shipment.shipMBEProducts?.some(product =>
        validIds.includes(product.idSpecialtyBusiness)
      ) || false
    );
  }
  checkSafeValue() {
    const safeValue = this.shipment.extraServices.find(
      e => e.mbeBusinessId === SurchargeExtraServiceBusiness.MBE_SAFEVALUE
    );
    if (safeValue) {
      //SAFE VALUE
      const existing = ShipmentService.getSpecialty(
        this.shipment,
        SpecialtyTypeBusiness.SAFEVALUE
      );
      const mbeProduct = {
        corporate: existing ? existing.corporate : null,
        costMBE: existing ? existing.costMBE : this.shipment.costMBE, // cp costMBE also on product
        idSpecialtyBusiness: SpecialtyTypeBusiness.SAFEVALUE, // for idSpecialtyBusiness use MBEBusinessId
        specialtyName: safeValue.extraServiceName,
        idWebService: existing ? existing.idWebService : 0
      };
      if (this.shipment.shipMBEProducts) {
        if (existing) {
          this.shipment.shipMBEProducts[
            this.shipment.shipMBEProducts.indexOf(existing)
          ] = mbeProduct;
        } else {
          this.shipment.shipMBEProducts.push(mbeProduct);
        }
      } else {
        this.shipment.shipMBEProducts = [mbeProduct];
      }
    }
  }
  checkSafeValue4B() {
    const safeValue4b = this.shipment.extraServices.find(
      e =>
        e.mbeBusinessId ===
        SurchargeExtraServiceBusiness.MBE_SAFEVALUE_4BUSINESS
    );
    const isAutopilotFee = this.shipment.extraServices.find(
      e => e.mbeBusinessId == 235
    );
    if (isAutopilotFee) this.shipment.autopilotFee = true;

    if (safeValue4b) {
      //SAFE VALUE
      const existing = ShipmentService.getSpecialty(
        this.shipment,
        SpecialtyTypeBusiness.SAFEVALUE_4BUSINESS
      );
      const mbeProduct = {
        corporate: existing ? existing.corporate : null,
        costMBE: existing ? existing.costMBE : this.shipment.costMBE, // cp costMBE also on product
        idSpecialtyBusiness: SpecialtyTypeBusiness.SAFEVALUE_4BUSINESS, // for idSpecialtyBusiness use MBEBusinessId
        specialtyName: safeValue4b.extraServiceName,
        idWebService: existing ? existing.idWebService : 0
      };
      if (this.shipment.shipMBEProducts) {
        if (existing) {
          this.shipment.shipMBEProducts[
            this.shipment.shipMBEProducts.indexOf(existing)
          ] = mbeProduct;
        } else {
          this.shipment.shipMBEProducts.push(mbeProduct);
        }
      } else {
        this.shipment.shipMBEProducts = [mbeProduct];
      }
    }
  }

  clearFields(shipmentType: string) {
    if (shipmentType.toLowerCase() === "sender") {
      this.shipment.addressFrom = new AddressShipmentDTO();
      // reset couriers and related infos on sender address change/clear
      (this.$refs.shipmentForm as ShipmentForm).syncShipmentOptions(
        "addressFromCountry",
        this.shipment.addressFrom
      );
    } else {
      this.shipment.addressTo = new AddressShipmentDTO();
      // reset couriers and related infos on receiver address change/clear
      (this.$refs.shipmentForm as ShipmentForm).syncShipmentOptions(
        "addressToCountry",
        this.shipment.addressTo
      );
    }
  }

  changeCanRequestCustomDuties(value: boolean) {
    this.canRequestCustomDuties = value;
  }

  @Watch("shipment.courierName")
  @Watch("shipment.addressFrom.province")
  @Watch("shipment.addressTo.province")
  provinceCourierNameChange() {
    if (this.shipment.courierName === "UPS") {
      this.shipment.addressFrom.province = this.shipment.addressFrom.province
        ? this.shipment.addressFrom.province.trim().toUpperCase()
        : "";
      this.shipment.addressTo.province = this.shipment.addressTo.province
        ? this.shipment.addressTo.province.trim().toUpperCase()
        : "";
    }
  }

  shipmentMessages: any[] = [];
  isSavePressed = false;

  confirmSaveShipment(draft?: boolean): Promise<void> {
    EventBus.$emit("show-my-full-loading");
    // set a long enough timeout to hide full-loading in case something strange happens
    setTimeout(() => EventBus.$emit("hide-my-full-loading"), 28000);

    // User can print waybill if its global configuration allows it
    // and if its per courier service configuration allows it.
    const courierServices = ((this.$refs.shipmentForm as ShipmentForm).$refs
      .calculator as Calculator).courierServices;
    let canPrintWaybill = this.$store.getters["customer/config"]
      .canPrintWaybill;
    if (courierServices !== undefined && courierServices !== null) {
      const filteredCourierServices = courierServices.filter(
        item => item.idBusiness === this.shipment.courierServiceId
      );
      if (filteredCourierServices.length > 0) {
        const courierService = filteredCourierServices[0];
        const courierServiceVisibilityConfiguration = this.$store.getters[
          "customer/courierVisibilityConfig"
        ].filter((item: any) => {
          return item.courierServiceId === courierService.idCourierService;
        });
        const config = courierServiceVisibilityConfiguration.find(
          config => config.shipmentType == this.shipment.shipmentType
        );
        if (courierServiceVisibilityConfiguration.length > 0 && config) {
          canPrintWaybill = canPrintWaybill && config.canPrintWaybill;
        }
      }
    }
    if (this.shipment.pickup !== null) {
      this.shipment.pickup.pickupSourceDescription =
        this.$store.getters.user.username + " (MOL)";
    }
    if (this.$route.params.duplicate !== "duplicate") {
      if (this.isInboundShipment) {
        this.shipment.shipmentDirection = "INBOUND";
      } else {
        this.shipment.shipmentDirection = "OUTBOUND";
      }
    }
    if (this.shipment.shipmentSource === "")
      this.shipment.shipmentSource = undefined;
    const shipmentToSave = JSON.parse(JSON.stringify(this.shipment));
    if (this.shipment.proforma && this.shipment.proforma.totalValue === 0) {
      shipmentToSave.proforma = undefined;
    }
    shipmentToSave.customerDataInSender = this.$store.getters[
      "customer/info"
    ].custConfiguration.customerAsSender;
    shipmentToSave.customerDataInSenderExceptForAddress = this.$store.getters[
      "customer/info"
    ].custConfiguration.customerAsSenderExceptforAddress;

    if (
      this.showTaxDutyLogic &&
      this.lastDetails &&
      this.lastDetails.landedCosts &&
      this.lastDetails.landedCosts.taxAndDutyId &&
      this.lastDetails.landedCosts.taxAndDutyId.length > 0
    ) {
      shipmentToSave.taxAndDutyId = this.lastDetails.landedCosts.taxAndDutyId;
      shipmentToSave.taxAndDutyPluginAct = true;
    }
    const zonosResponse = this.$store.getters[
      "shipment/zonosCalculateResponse"
    ];
    shipmentToSave.zonosId =
      this.showTaxDutyLogic && zonosResponse && zonosResponse.zonosId
        ? zonosResponse.zonosId
        : undefined;

    if (shipmentToSave && shipmentToSave.taxAndDutyId) {
      shipmentToSave.taxAndDutyId = undefined;
    }

    if (!draft) {
      if (
        shipmentToSave.courierName === "" ||
        shipmentToSave.courierName == null
      ) {
        delete shipmentToSave.courierName;
        this.isSavePressed = true;
        shipmentToSave.courierId = 0;
        shipmentToSave.courierServiceId = 0;
      }
      if (shipmentToSave.pickup) {
        delete shipmentToSave.pickup.bookingIdentificationNumber;
        delete shipmentToSave.pickup.checksum;
        delete shipmentToSave.pickup.creationDate;
        delete shipmentToSave.pickup.deleted;
        delete shipmentToSave.pickup.rejectedReason;
        delete shipmentToSave.pickup.requestLocation;
      }

      if (this.$cookies.isKey("POPUP_SAFEVALUESHIPMENT_TEXT")) {
        this.shipmentMessages.push({
          code: "POPUP_SAFEVALUESHIPMENT_TEXT",
          responseType: "WARNING",
          fields: ["safevalue"]
        } as MessageResult);
      }
      return ShipmentService.saveShipment(
        shipmentToSave,
        this.$store.getters["customer/info"].tenantId,
        this.$store.getters["customer/info"].multiStoreId,
        canPrintWaybill,
        true,
        this.shipmentMessages
      )
        .then(async (res: any) => {
          EventBus.$emit("hide-my-full-loading");
          this.shipmentMessages = [];
          this.isSavePressed = true;

          const successMessages =
            (res.messageResultSuccess && res.messageResultSuccess.messages) ||
            [];
          if (successMessages && successMessages.length > 0) {
            let dangerMessage = `
              <h5>${this.$t("notification_shipment_saved_message")}</h5></br>
              </br>
              <ul>
            `;
            const dangerMessageCookies = {
              messagesLength: successMessages.length,
              dontAskAgain: []
            };

            successMessages.forEach(message => {
              if (
                message.code === "TNT_WARN_RECEIVER_FIELD_CHANGED" &&
                message.checked == false
              ) {
                dangerMessage += `
                  <li>
                    ${this.$t("TNT_WARN_RECEIVER_FIELD_CHANGED")}:</br>
                    <i>${this.$t(
                      message.fields[0].toString().toLowerCase()
                    )}</i> ${this.$t("from")} "${message.params[0]}"" ${this.$t(
                  "to"
                )} "${message.params[1].toString().toLowerCase()}"
                  </li>
                `;
              }
            });

            dangerMessage += `</ul>`;
            const response = await AlertBus.$alerts.danger(
              dangerMessage,
              dangerMessageCookies
            );
          }

          const messages =
            (res.messageResult && res.messageResult.messages) || [];
          if (
            (this.$refs.shipmentForm as ShipmentForm)
              .calculateTaxDutyBtnTriggered &&
            (this.$refs.shipmentForm as ShipmentForm).isProformaIncotermDAP
          ) {
            messages.push({
              code: "DAP_SHIPMENT",
              responseType: "WARNING"
            });
          }

          if (messages && messages.length > 0) {
            // There are some errors
            let title = "<ul>";
            let updateZTL = false;
            messages.forEach((mex: any) => {
              this.shipmentMessages.push(mex);
              let message = String(this.$t(mex.code));
              if (mex.responseType === "ERROR") {
                // for courier exception(s) that can have unknown errors from ext. systems

                if (!hasTranslation(mex.code)) {
                  let msgCode = mex.code;
                  if (mex.code === undefined) {
                    msgCode = this.$t("UNEXPECTED_ERROR");
                  }
                  message = this.$t(msgCode) + " " + mex.description;
                } else {
                  message = this.$t(mex.code);
                }
              }
              title += "<li>" + message + "</li>";
              if (mex.code === "AUTO_ADDED_SURCHARGE_ALERT") {
                const params = mex.params;
                for (const param of params) {
                  let value = param;
                  if (!isNaN(param)) {
                    value = this.$t("extraService_" + param);
                  }
                  title += "&nbsp;- " + value + "<br/>";
                }
              }
              if (mex.code === "GLS_WARN_RECEIVER_ZTL") {
                //we ask to confirm address update
                updateZTL = true;
              }
            });
            if (messages.some((mex: any) => mex.responseType === "ERROR")) {
              let message =
                "<h5>" + this.$t("FIX_BEFORE_CONTINUE") + "</h5></br>";
              message += title + "</ul>";
              if (
                messages.some(
                  (mex: any) => mex.code === "DPD_EXCEEDED_WEIGHT_LIMIT"
                )
              ) {
                return AlertBus.$alerts.danger(
                  this.$t("DPD_EXCEEDED_WEIGHT_LIMIT")
                );
              }
              return AlertBus.$alerts.danger(message);
            }

            let message = "<h5>" + this.$t("SAVE_ANYWAY") + "</h5></br>";
            message += title + "</ul>";

            const messageCookies = {
              messagesLength: messages.length,
              dontAskAgain: []
            };
            let hasSafeValueShipmentText = false;
            if (
              messages.find(el => el.code === "POPUP_SAFEVALUESHIPMENT_TEXT")
            ) {
              hasSafeValueShipmentText = true;
              messageCookies.dontAskAgain.push("POPUP_SAFEVALUESHIPMENT_TEXT");
              if ((window as any).dataLayer) {
                const layerData = {
                  event: "open_popup",
                  event_data: {
                    services: "Safe Value"
                  }
                };
                (window as any).dataLayer.push(layerData);
              }
            }

            AlertBus.$alerts
              .confirm(message, messageCookies)
              .then((resp: boolean) => {
                if (resp) {
                  if (hasSafeValueShipmentText) {
                    if ((window as any).dataLayer) {
                      const layerData = {
                        event: "confirm",
                        event_data: {
                          services: "Safe Value"
                        }
                      };
                      (window as any).dataLayer.push(layerData);
                    }
                  }
                  if (updateZTL) {
                    this.shipment.addressTo.ltz = true;
                  }

                  (this.$refs
                    .shipmentForm as ShipmentForm).calculateTaxDutyBtnTriggered = false;
                  this.confirmSaveShipment();
                } else {
                  if (hasSafeValueShipmentText) {
                    if ((window as any).dataLayer) {
                      const layerData = {
                        event: "denied",
                        event_data: {
                          services: "Safe Value"
                        }
                      };
                      (window as any).dataLayer.push(layerData);
                    }
                  }
                  this.isSavePressed = false;
                  this.shipmentMessages = [];
                }
              });
          } else {
            this.shipment.shipmentId = res.shipment.shipmentId;
            this.shipment.status = res.shipment.status;
            this.isSavePressed = false;
            this.$snotify.success(
              this.$t("notification_shipment_created").toString()
            );
            this.uploadAttachments(this.shipment.shipmentId);

            const modalConstructor = Vue.extend(PostSaveModal);
            const modal = new modalConstructor({
              i18n,
              router,
              store,
              propsData: {
                shipment: this.shipment
              }
            });
            EventBus.$emit("to-modal", modal);
          }
        })
        .then(res => res.data)
        .catch(err => {
          if (err.code && err.code === "ECONNABORTED") {
            setTimeout(() => {
              AlertBus.$alerts.danger(i18n.t("shipments_timeout")).then(() => {
                this.$router.push({
                  name: "ShipmentsMenuNew",
                  params: {}
                });
              });
            }, 100);
          }
        });
    } else {
      if (
        this.shipment.addressTo.macroareaName === "" &&
        !this.isInboundShipment
      ) {
        const macroAreaTo = ((this.$refs.shipmentForm as ShipmentForm).$refs
          .addressTo as Address).subcountries[0].macroareaName;
        this.shipment.addressTo.macroareaName =
          macroAreaTo !== "" ? macroAreaTo : "NATIONAL";
      }
      if (
        this.shipment.addressFrom.macroareaName === "" &&
        this.isInboundShipment
      ) {
        const macroAreaFrom = ((this.$refs.shipmentForm as ShipmentForm).$refs
          .addressFrom as Address).subcountries[0].macroareaName;
        this.shipment.addressTo.macroareaName =
          macroAreaFrom !== "" ? macroAreaFrom : "NATIONAL";
      }
      if (
        this.showTaxDutyLogic &&
        this.lastDetails &&
        this.lastDetails.landedCosts &&
        this.lastDetails.landedCosts.taxAndDutyId &&
        this.lastDetails.landedCosts.taxAndDutyId.length > 0 &&
        this.shipment.ddpZonos
      ) {
        this.shipment.taxAndDutyId = this.lastDetails.landedCosts.taxAndDutyId;
        this.shipment.taxAndDutyPluginAct = true;
      } else {
        this.shipment.taxAndDutyId = undefined;
        this.shipment.taxAndDutyPluginAct = false;
      }
      const zonosResponse = this.$store.getters[
        "shipment/zonosCalculateResponse"
      ];
      this.shipment.zonosId =
        this.showTaxDutyLogic && zonosResponse && zonosResponse.zonosId
          ? zonosResponse.zonosId
          : undefined;

      return ShipmentService.saveShipmentDraft(
        this.shipment,
        this.$store.getters["customer/info"].tenantId,
        this.$store.getters["customer/info"].multiStoreId
      ).then((res: any) => {
        EventBus.$emit("hide-my-full-loading");
        this.shipment.shipmentId = res.shipment.shipmentId;
        this.shipment.status = res.shipment.status;
        this.uploadAttachments(this.shipment.shipmentId);
        this.$snotify.success(
          this.$t("notification_shipment_created").toString()
        );
        this.$router.push({
          name: "ShipmentsMenuNew",
          params: {}
        });
      });
    }
  }
  confirmAttachments(documents: any) {
    this.attachments = documents;
  }
  uploadAttachments(shipmentId: string) {
    if (this.attachments) {
      this.attachments.forEach(att => {
        ShipmentService.uploadAttachments(shipmentId, att.files)
          .then(() => {
            this.$snotify.success(this.$t("attachments_uploaded").toString());
          })
          .catch(reason => {
            this.$alerts.danger(translateErrorMessage(reason));
          });
      });
    }
  }

  addExtraService(extraService: ShipmentExtraServiceDTO) {
    this.shipment.extraServices = this.shipment.extraServices.filter(
      item => item.extraServiceName !== extraService.extraServiceName
    );
    extraService.price = true;
    this.shipment.extraServices.push(extraService);
    if (this.shipment.dismissedExtraServices) {
      this.shipment.dismissedExtraServices = this.shipment.dismissedExtraServices.filter(
        item => item.extraServiceName !== extraService.extraServiceName
      );
    }
  }

  unmounted() {
    this.$snotify.clear();
  }

  get showTaxDutyLogic() {
    return this.$store.getters.taxDutyEnabled && this.isTaxDutyEnabled;
  }

  get isTaxDutyEnabled() {
    return this.$store.getters["customer/isTaxDutyEnabled"] as boolean;
  }

  removeExtraService(event: any) {
    const extraService = this.shipment.extraServices.filter(
      item => item.extraServiceName === event.extraServiceName
    )[0];
    if (!event.autoAdded) {
      this.shipment.extraServices = this.shipment.extraServices.filter(
        item => item.extraServiceName !== event.extraServiceName
      );
    } else {
      this.shipment.extraServices.forEach((item, index) => {
        if (item.extraServiceName === event.extraServiceName) {
          this.shipment.extraServices[index].dismissed = true;
          this.shipment.extraServices[index].price = false;
          this.shipment.extraServices[index].cost = false;
        }
      });
    }
    extraService.dismissed = true;
    extraService.price = false;
    extraService.cost = false;
    this.shipment.dismissedExtraServices.push(extraService);
  }

  deleteSenderAddress() {
    //this.shipment.addressFrom = new AddressShipmentDTO();
    this.senderAddressOperation = "NEW";
    this.senderContact = undefined;
  }

  saveAsPickup() {
    this.senderAddressOperation = "SAVEASPICKUP";
  }

  deleteReceiverAddress() {
    //this.shipment.addressTo = new AddressShipmentDTO();
    this.receiverAddressOperation = "NEW";
    this.receiverContact = undefined;
  }

  senderAddressLoaded(contact: ContactDTO) {
    this.senderAddressOperation = "OVERWRITE";
    this.senderContact = contact;
  }

  receiverAddressLoaded(contact: ContactDTO) {
    this.receiverAddressOperation = "OVERWRITE";
    this.receiverContact = contact;
  }

  refreshStoreAddress() {
    const storeAddresses = this.$store.getters["customer/storeAddresses"];
    const storeName = getStoreCompanyName(
      this.$store.getters["customer/storeInfo"].store.multiStore
    );
    if (storeAddresses.length >= 1) {
      this.shipment.addressStore = AddressShipmentDTO.fromAddressDTO(
        storeAddresses[0],
        storeName,
        "",
        "NATIONAL",
        this.$store.getters["customer/storeInfo"].contactReferences
      );
    }
  }

  getCorrectionSettings() {
    const cfgPage = {
      pageNumber: 0,
      pageSize: 30
    } as Page;

    if (
      !(
        this.shipment.importedShipment == true &&
        this.shipment.excludeInvoiceCheck == true &&
        this.shipment.correctionSettings
      )
    ) {
      ShipmentService.getInvoiceCheckConfigurations(
        cfgPage,
        this.$store.getters["customer/customerMbeId"]
      ).then(res => {
        this.shipment.correctionSettings = {
          priceUpdate: res.content[0].priceUpdate,
          courierWeightUpdate: res.content[0].courierWeightUpdate,
          customerWeightUpdate: res.content[0].customerWeightUpdate,
          createInvoiceRevision: res.content[0].createInvoiceRevision,
          minAmountForInvoiceRevision:
            res.content[0].minAmountForInvoiceRevision,
          includeRefunds: res.content[0].includeRefunds
        };
      });
    }
  }
}
